import { API } from '../../api'
import { chatServiceUrl } from '../../utils/constants'

/** A prompt the user saved to reuse later. Private to that user. */
export interface SavedPrompt {
  id: string
  prompt: string
  /** Naive UTC (no `Z`), nullable in the schema though always set in practice. */
  created_at?: string | null
  updated_at?: string | null
}

/** Newest-first — render in the order returned. */
export interface SavedPromptsResponse {
  prompts: SavedPrompt[]
}

const promptsUrl = (partnerId: string) =>
  `${chatServiceUrl}/v2/partners/${partnerId}/prompts`

/** Saves `prompt` for `userId` and returns the created row, including its id. */
export const saveChatPromptAPI = (
  partnerId: string,
  userId: string,
  prompt: string
) => API.post<SavedPrompt>(promptsUrl(partnerId), { user_id: userId, prompt })

/**
 * Lists everything this user saved for this partner, newest-first. Unpaginated
 * — the endpoint returns the whole list.
 */
export const getChatPromptsAPI = (partnerId: string, userId: string) =>
  API.get<SavedPromptsResponse>(promptsUrl(partnerId), {
    params: { user_id: userId },
  })

/**
 * Permanently deletes one saved prompt. Responds 204 with an empty body, and
 * 404 both for an unknown id and for one belonging to another user — the two
 * are deliberately indistinguishable, so treat either as "the row is gone".
 */
export const deleteChatPromptAPI = (
  partnerId: string,
  userId: string,
  promptId: string
) =>
  API.delete<void>(`${promptsUrl(partnerId)}/${promptId}`, {
    params: { user_id: userId },
  })
